module.exports = function() {
  return new Worker(__webpack_public_path__ + "2867409998142e3d45e7.worker.js");
};